import { AccountServiceService } from "src/app/services/AccountService";

export const App = {
    auth: {
        permissions: [] as string[],
        isGranted(policy: string) {
            return this.permissions.includes(policy);
        },
        getPermissions(accountService: AccountServiceService) {
            if (this.permissions.length === 0) {
                accountService.GetPermissions().subscribe(
                    (permissions: string[]) => {
                        permissions.forEach(element => {
                            this.permissions.push(element);
                        });
                    },
                    (error) => {
                        this.permissions = [];
                    }
                )
            }
        }
    }
};